import { render } from "./GameHistoryList.vue?vue&type=template&id=77164814&scoped=true&ts=true"
import script from "./GameHistoryList.vue?vue&type=script&lang=ts"
export * from "./GameHistoryList.vue?vue&type=script&lang=ts"

import "./GameHistoryList.vue?vue&type=style&index=0&id=77164814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77164814"]])

export default __exports__